import BaseMixin from './base.mixin'

const mixin = {
  mixins: [BaseMixin],
  methods: {
    cancelExamFromInvalidFileStatus(examId, reason) {
      return this.requestPut('/core/Exam/CancelFromAllowedStatus', { examId, reason })
    },
    updateExamFromPendingInformationStatus(examId, body) {
      return this.requestPut(`/core/Exam/${examId}/UpdateFromPendingInformationStatus`, body)
    }
  }
}

export default mixin
